export default {
    'AccessWhitelist': {
        '4': 5906426,
        '1': 9410101
    },
}